import LogoutIcon from "@mui/icons-material/Logout";
import { Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { saveChat } from "../../../../../redux/actions/call";
import { convertDateTimeToNet } from "../../../../../utils/datetime";
import { closeIframe } from "../../../../../utils/iframe";
import CallButton from "../../../../commons/callButton/CallButton";
import { PopoverItem, StyledPopover } from "../../../../styled/LeaveRoomButton";

const LeaveRoomButton = ({ room, messages }) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const idRoom = searchParams.get("id");
  const esHost = room?.isHost();
  const esProfesional =
    room?.getCurrentUserInfo()?.userIdentity === "Profesional";
  const puedeFinalizarReunion = esHost && esProfesional;
  const saveChatMessages = () => {
    if (esProfesional && messages.length > 0) {
      const mensajesWithIdSala = {
        idSala: idRoom,
        mensajes: messages.map((msg) => ({
          ...msg,
          fechaHoraEnvio: convertDateTimeToNet(msg.fechaHoraEnvio),
        })),
      };
      return dispatch(saveChat(mensajesWithIdSala));
    }
  };
  const handleFinalizarReunion = async () => {
    await saveChatMessages();
    closeIframe();
    room.leave(true).then((res) => {
      const siteUrl = window.location.origin;
      window.location.href = siteUrl;
    });
  };
  const handleSalirReunion = async () => {
    if (esProfesional) {
      await saveChatMessages();
    }
    closeIframe();
    room.leave().then((res) => {
      const siteUrl = window.location.origin;
      window.location.href = siteUrl;
    });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {puedeFinalizarReunion ? (
        <div>
          <CallButton
            tooltipText="Salir de la Reunión"
            src={<LogoutIcon />}
            usarIconoEnBlanco={true}
            leaveRoomButton={true}
            action={Boolean(anchorEl) ? handleFinalizarReunion : handleClick}
          />
          <StyledPopover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "left",
            }}>
            <PopoverItem onClick={handleSalirReunion}>
              <Typography>Salir de la reunión</Typography>
            </PopoverItem>
            <Tooltip
              title="Todos los participantes saldrán!"
              dir="bottom"
              placement="bottom"
              arrow>
              <PopoverItem onClick={handleFinalizarReunion}>
                <Typography>Terminar reunión</Typography>
              </PopoverItem>
            </Tooltip>
          </StyledPopover>
        </div>
      ) : (
        <CallButton
          tooltipText="Salir de la Reunión"
          src={<LogoutIcon />}
          leaveRoomButton
          action={handleSalirReunion}
          usarIconoEnBlanco={true}
        />
      )}
    </>
  );
};

export default LeaveRoomButton;
